import React, { useEffect, useState } from "react";
import { axios } from "../../../../Global";
import { useDispatch } from "react-redux";
import ListDataFileManagerCandiate from "./ListDataCandidates";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";

export default function FileManagerCandidate() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [candidateData, setCandidateData] = useState([]);
  const fetchCandidates = async () => {
    try {
      const res = await axios.get(`/dashboard/file-manager/candidate`);
      setLoading(false);
      setCandidateData(res.data?.data);
    } catch (error) {
      console.log(error);
      dispatch(
        setAppError({ msg: error?.response?.data?.message || error?.message })
      );
    }
  };
  useEffect(() => {
    fetchCandidates();
  }, []);

  const breadcrumbItems = [
    { label: "File Manager", link: "/dashboard/candidates" },
    { label: "Candidates", link: "/dashboard/candidates" },
  ];

  useEffect(() => {
    dispatch(setBreadCrumb(breadcrumbItems));
  }, []);

  return (
    <>
      <div className="p-2  sm:p-5 ">
        {!loading ? (
          <ListDataFileManagerCandiate
            candidateData={candidateData}
            loading={loading}
            titles={[
              "SL NO.",
              "Employee ID",
              "Passport No.",
              "Name",
              "Passport",
              "VISA",
              "Vaccine",
              "Driving License",
              "Signed Employee Contract",
              "Signed Absent Policy",
            ]}
          />
        ) : (
          <LoadingWithLable />
        )}
      </div>
    </>
  );
}
